import { addTraits } from 'src/api';

export const getVendors = state => addTraits(state.vendor.vendor);
